module.exports = __webpack_public_path__ + "h5/img/begin.610a2733.png";